module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.strichTabelleUpdate(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-left": 65,
      "nudge-bottom": 10,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": ""
          }
        }, on), [_c('span', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.$filters.date(_vm.date)))])])]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de"
    },
    on: {
      "input": _vm.getDatepicker
    },
    model: {
      value: (_vm.datepicker),
      callback: function($$v) {
        _vm.datepicker = $$v
      },
      expression: "datepicker"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.strichTabelleUpdate(1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mt-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Bundesbruder",
      "items": _vm.bundesbruderselect
    },
    model: {
      value: (_vm.bbrID),
      callback: function($$v) {
        _vm.bbrID = $$v
      },
      expression: "bbrID"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.stricheSet(-1)
      }
    }
  }, [_vm._v("-1")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.stricheSet(+1)
      }
    }
  }, [_vm._v("+1")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "EKP-Getränke",
      "items": _vm.getrankeselect
    },
    model: {
      value: (_vm.ekp),
      callback: function($$v) {
        _vm.ekp = $$v
      },
      expression: "ekp"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "3",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "name": "",
      "label": "Anzahl Getränke",
      "id": ""
    },
    model: {
      value: (_vm.ekp_anzahl),
      callback: function($$v) {
        _vm.ekp_anzahl = $$v
      },
      expression: "ekp_anzahl"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "3",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "name": "",
      "label": "Pauschal",
      "id": ""
    },
    model: {
      value: (_vm.pauschal),
      callback: function($$v) {
        _vm.pauschal = $$v
      },
      expression: "pauschal"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8",
      "sm": "5",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "name": "",
      "label": "Grund",
      "id": ""
    },
    model: {
      value: (_vm.grund),
      callback: function($$v) {
        _vm.grund = $$v
      },
      expression: "grund"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-9 primary",
    attrs: {
      "absolute": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "small": "",
      "fab": ""
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "pt-2 pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "calc(100vh - 510px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Was")]), _vm._v(" "), _c('th', [_vm._v("Anzahl")]), _vm._v(" "), _c('th', [_vm._v("Preis")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.was))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.preis)))]), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          return _vm.deleteStrich(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pt-4 text-right",
    attrs: {
      "cols": "8"
    }
  }, [_vm._v("\n      Die Positionen werden nur gespeichert. "), _c('br'), _vm._v("\n      Die Rechnung kann unter Strichliste erstellt werden.\n    ")]), _vm._v(" "), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Summe",
      "readonly": "",
      "value": _vm._f("money")(_vm.summe)
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-btn', {
    attrs: {
      "large": ""
    },
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('br')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d679d28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/bierwartVeranstaltung.vue
// module id = 761
// module chunks = 15